<template>
  <div style="user-select: none;" class="flex option-container items-center">
    <div class="col-6 flex flex-wrap">
      <div :class="['col-12', { 'disabled': isDisabled || !isActive}]">
        <div class="bold h6">{{ localOption.name.toLowerCase() }}</div>
        <div class="bold h6">{{ getUnitPrice }}€</div>
      </div>
    </div>
    <div class="col-6 flex flex-wrap">
      <div class="col-6 flex items-center justify-center">
        <i v-if="showQuantityChanger && !isDisabled && !isOptionQuantitySelectedDisabled" style="top: 2px" :class="[{'icon icon-minus pointer': true},{'disabled':canShow(-1)}]" @click="handleQuantityChange(-1)"></i>
        <span class="mx2 h6 bold">{{ localOption.quantity }}</span>
        <i v-if="showQuantityChanger && !isDisabled && !isOptionQuantitySelectedDisabled" style="top: 2px" :class="[{'icon icon-add-more-icon pointer':true},{'disabled':canShow(1)}]" @click="handleQuantityChange(1)"></i>
      </div>
      <div class="col-6 flex items-center justify-end">
        <div v-if=" getPrice > 0 || (getUnitPrice > 0 && localOption.quantity === 0)" class="h6 bold cond lower">{{ getPrice.toFixed(2) }} €<span v-if="isOptionRecurring" class="h6 bold"> / mois</span></div>
        <div v-else class="h6 bold cond lower">Offert</div>
      </div>
    </div>
  </div>
</template>
<script>
import { optionTypes } from '@/utils/utils';

export default {
  props: {
    option: Object,
    isActive: Boolean
  },
  data () {
    return {
      optionTypes: optionTypes,
      availableOptions: this.$store.state.availableOptions,
      localOption: {
        ...this.$props.option,
        quantity: !this.option.fixedQuantity ? 0 : 1
      }
    };
  },
  computed: {
    isInternalSession () {
      return this.$store.state.siteInfo && this.$store.state.siteInfo.is_internal_session;
    },
    showQuantityChanger () {
      return this.option.fixedQuantity ? this.option.quantity > 1 : true;
    },
    getPrice () {
      if (this.$store.state.currentParticipant) {
        const price = this.localOption.detail.prices.find(p => p.tariffCategoryCode === this.$store.state.currentParticipant.tariff.tariffCategoryCode);

        if (this.localOption.promo) {
          const promo = price.promotions.find(prom => prom.id === this.localOption.promo.id);

          if (promo) {
            return this.localOption.quantity * promo.discount_price;
          }
        }

        return this.localOption.quantity * parseFloat(price.price / 100);
      }
      return null;
    },
    getUnitPrice () {
      if (this.$store.state.currentParticipant) {
        const price = this.localOption.detail.prices.find(p => p.tariffCategoryCode === this.$store.state.currentParticipant.tariff.tariffCategoryCode);

        if (this.localOption.promo) {
          const promo = price.promotions.find(prom => prom.id === this.localOption.promo.id);

          if (promo) {
            return promo.discount_price;
          }
        }
        return parseFloat(price.price / 100);
      }
      return null;
    },
    isDisabled () {
      return this.localOption.optionType === this.optionTypes.MANDATORY;
    },
    isOptionQuantitySelectedDisabled () {
      return this.localOption.detail.recurring;
    },
    isOptionRecurring () {
      return this.$store.state.offerInfo.detail.recurring && !this.option.registrationFees;
    }
  },
  methods: {
    canAdd (quantityToUpdate) {
      if (this.localOption.fixedQuantity) {
        const optionInAvailableOptions = this.availableOptions.find(option => {
          if (this.isInternalSession) {
            return option.uuid === this.localOption.uuid;
          }
          return option.horanet_product.horanet_product_code === this.localOption.horanet_product.horanet_product_code;
        });
        if (optionInAvailableOptions && optionInAvailableOptions.quantity < quantityToUpdate) {
          return false;
        }
      } else if (this.localOption.optionType === this.optionTypes.MANDATORY && quantityToUpdate === 0) {
        return false;
      }
      return true;
    },
    canShow (quantity) {
      const quantityToUpdate = parseInt(this.localOption.quantity) + (quantity);
      const canAdd = this.canAdd(quantityToUpdate);

      if (quantityToUpdate === -1) {
        return true;
      }
      return !canAdd;
    },
    handleQuantityChange (quantity) {
      const quantityToUpdate = parseInt(this.localOption.quantity) + (quantity);
      const canAdd = this.canAdd(quantityToUpdate);

      if (!canAdd) {
        return;
      }

      this.localOption.quantity = quantityToUpdate > 0 ? quantityToUpdate : 0;
      this.$emit('manageOption', { ...this.localOption });
    },
    toggleOption () {
      if (this.localOption.optionType === this.optionTypes.OPTIONAL) {
        this.$emit('manageOption', { ...this.localOption });
      }
    }
  }
};
</script>

<style scoped>
  @media (max-width: 40em) {
    .option-container{
      flex-wrap: wrap;
    }
  }
</style>
